/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Node_ConditionsInputs */

const cs_workflow_node_conditions = /** @type {(inputs: Workflow_Node_ConditionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podmínky`)
};

const en_workflow_node_conditions = /** @type {(inputs: Workflow_Node_ConditionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conditions`)
};

/**
* | output |
* | --- |
* | "Conditions" |
*
* @param {Workflow_Node_ConditionsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_node_conditions = /** @type {((inputs?: Workflow_Node_ConditionsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Node_ConditionsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_node_conditions(inputs)
	return cs_workflow_node_conditions(inputs)
});